module.exports = __webpack_public_path__ + "static/media/m_eyeshape_monolid_amber.3eaf2182.png";